import { render } from "./list-ir.vue?vue&type=template&id=2f315123"
import script from "./list-ir.vue?vue&type=script&lang=js"
export * from "./list-ir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__